import React from 'react';
import { atom } from 'recoil';

import { ExtendedFlashbarProps } from '../models/ExtendedFlashbar';

export const key = 'notificationsState';

export const initialState = [];

export const state = atom<ExtendedFlashbarProps[]>({
    key,
    default: initialState,
});
